import checkboxOptions from './checkboxOptions';
import { KD_COUNTRY, KD_STATE, KD_CITY } from '../../constants';

export const mainSelectorOptions = {
  anyOption: {
    value: 'defaultAny',
    label: 'Any Geography',
    first: true,
  },
  specifyOption: {
    value: 'defaultSpecify',
    label: 'Specify A Location',
    first: false,
  },
};

export { checkboxOptions };

export const typeOptions = [
  {
    label: 'City',
    value: KD_CITY,
  },
  {
    label: 'State',
    value: KD_STATE,
  },
  {
    label: 'Country',
    value: KD_COUNTRY,
  },
];



// WEBPACK FOOTER //
// ./app/components/KdSelectGeography/optionsValue.js